<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <h1>招贤纳士</h1>
        <div class="tabs">
          <a class="tab-item active">
            <div class="tag"></div>
            公司概况
          </a>
          <a href="#good" class="tab-item">
            <div class="tag"></div>
            优势福利
          </a>
          <a href="#life" class="tab-item">
            <div class="tag"></div>
            工作生活
          </a>
          <a href="#job" class="tab-item">
            <div class="tag"></div>
            招聘职位
          </a>
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 招贤纳士</div>
    </div>

    <section class="section intro" ref="introSection">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">公司概况</div>
        </h2>
        <div class="desc">
          <p>
            苏州星翰新材料科技有限公司（简称“星翰材料”），成立于2019年6月，是一家专注于电子粉体及下游金属化解决方案研发、生产和销售的国家级专精特新“小巨人”企业，
          </p>
          <p>
            也是国内少数具备“粉浆一体化”量产能力，实现全链条自主可控的平台型电子专用材料供应商。
          </p>
          <p>
            公司以“以材料进步创建美好生活”为使命，致力于解决新能源与半导体领域关键材料的“卡脖子”问题，推动高性能电子材料的国产化进程。
          </p>
        </div>
        <div class="numbers">
          <div class="number_item">
            <NumberCounter
              :target="97"
              suffix="%"
              :start-animation="introVisible"
            />
            <p>本科以上学历</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="70"
              suffix="+"
              :start-animation="introVisible"
            />
            <p>博士与硕士</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="10"
              suffix="+"
              :start-animation="introVisible"
            />
            <p>合作高校与科研机构</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="20"
              suffix="+"
              :start-animation="introVisible"
            />
            <p>核心骨干行业经验</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section good" id="good">
      <div class="section-container">
        <div class="img-wrapper">
          <div class="advantages advantages_pc">
            <div class="item">
              <img src="../static/job/advavtage1.png" alt="" />
              <div class="txt">行业领先</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage2.png" alt="" />

              <div class="txt">技术前沿</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage3.png" alt="" />

              <div class="txt">发展迅速</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage4.png" alt="" />

              <div class="txt">晋升机制</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage5.png" alt="" />

              <div class="txt">成长空间</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage6.png" alt="" />

              <div class="txt">绩效奖励</div>
            </div>
          </div>

          <div class="benefit benefit_pc">
            <div class="item">
              <img src="../static/job/benefit1.png" alt="" />
              <div class="txt">社会保障完善</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit2.png" alt="" />
              <div class="txt">免费工作餐饮</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit3.png" alt="" />
              <div class="txt">宿舍配置齐全</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit4.png" alt="" />
              <div class="txt">节日福利丰富</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit5.png" alt="" />
              <div class="txt">团建活动精彩</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit6.png" alt="" />
              <div class="txt">统一工作着装</div>
            </div>
          </div>

          <div class="advantages advantages_mobile advantages1">
            <div class="item">
              <img src="../static/job/advavtage1.png" alt="" />
              <div class="txt">行业领先</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage2.png" alt="" />

              <div class="txt">技术前沿</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage3.png" alt="" />

              <div class="txt">发展迅速</div>
            </div>
          </div>

          <div class="advantages advantages_mobile advantages2">
            <div class="item">
              <img src="../static/job/advavtage4.png" alt="" />

              <div class="txt">晋升机制</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage5.png" alt="" />

              <div class="txt">成长空间</div>
            </div>
            <div class="item">
              <img src="../static/job/advavtage6.png" alt="" />

              <div class="txt">绩效奖励</div>
            </div>
          </div>

          <div class="benefit benefit1 benefit_mobile">
            <div class="item">
              <img src="../static/job/benefit1.png" alt="" />
              <div class="txt">社会保障完善1</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit2.png" alt="" />
              <div class="txt">免费工作餐饮</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit3.png" alt="" />
              <div class="txt">宿舍配置齐全</div>
            </div>
          </div>

          <div class="benefit benefit2 benefit_mobile">
            <div class="item">
              <img src="../static/job/benefit4.png" alt="" />
              <div class="txt">节日福利丰富</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit5.png" alt="" />
              <div class="txt">团建活动精彩</div>
            </div>
            <div class="item">
              <img src="../static/job/benefit6.png" alt="" />
              <div class="txt">统一工作着装</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="section work" id="life" data-aos="fade-up" data-aos-delay="200">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">工作在星翰</div>
          <div class="tag"></div>
        </h2>

        <div class="work_pc">
          <HorizontalScrollInterval
            :items="workImages"
            :gap="10"
            :paddingX="65"
          >
            <template v-slot="{ index, item }">
              <div class="partner-logo">
                <img :src="item" alt="" />
              </div>
            </template>
          </HorizontalScrollInterval>
        </div>
        <div class="work_mobile">
          <el-carousel
            :interval="5000"
            arrow="always"
            height="192px"
            indicator-position="none"
            :autoplay="true"
          >
            <el-carousel-item v-for="(img, index) in workImages" :key="index">
              <div class="custom">
                <img :src="img" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <section class="section life">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">生活在星翰</div>
          <div class="tag"></div>
        </h2>
        <div class="life_pc">
          <HorizontalScrollInterval
            :items="lifeImages"
            :gap="10"
            :paddingX="65"
          >
            <template v-slot="{ index, item }">
              <div class="partner-logo">
                <img :src="item" alt="" />
              </div>
            </template>
          </HorizontalScrollInterval>
        </div>
        <div class="life_mobile">
          <el-carousel
            :interval="5000"
            arrow="always"
            height="192px"
            indicator-position="none"
            :autoplay="true"
          >
            <el-carousel-item v-for="(img, index) in lifeImages" :key="index">
              <div class="custom">
                <img :src="img" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <section class="section job" id="job">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">招聘职位</div>
          <div class="tag"></div>
        </h2>

        <div class="job_list">
          <div
            class="job_item"
            v-for="(item, index) in jobs"
            :key="index"
            @click="openJobDetail(item)"
          >
            <div class="head">
              <div class="left">
                <img src="../static/job/user.png" alt="" />
                <div class="job_name">{{ item.positionName }}</div>
              </div>
              <div class="right">TIME {{ item.createTime }}</div>
            </div>
            <div class="detail">
              <div class="left">
                <div class="item">学历：{{ item.education }}</div>
                <div class="item">招聘人数：{{ item.hireCount }} 名</div>
                <div class="item">年薪范围：{{ item.salaryRange }}</div>
                <div class="item">工作地点：{{ item.workLocation }}</div>
                <div class="item">专业：{{ item.major }}</div>
                <div class="arrow"></div>
              </div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分页 -->
    <el-pagination
      v-if="total"
      layout="prev, pager, next"
      :total="total"
      :current-page="pageIndex"
      :page-size="pageSize"
      @current-change="
        (val) => {
          pageIndex = val;
          getNewsList();
        }
      "
    ></el-pagination>

    <!-- 联系我们 -->
    <contactModule title="加入我们，携手踏上新的征程" btnTxt="投递简历" email="hr@xinghanmaterials.com" />

    <Footer />

    <div class="dialog_masker" v-if="showDialog">
      <div class="dialog_content">
        <div class="header">
          <div class="job_name">{{ currentJob.positionName }}</div>
          <div class="details">
            <div class="left">
              <div class="item">学历：{{ currentJob.education }}</div>
              <div class="item">招聘人数：{{ currentJob.hireCount }} 名</div>
              <div class="item">年薪范围：{{ currentJob.salaryRange }}</div>
              <div class="item">工作地点：{{ currentJob.workLocation }}</div>
              <div class="item">专业：{{ currentJob.major }}</div>
            </div>
            <a class="submit_btn" href="mailto:hr@xinghanmaterials.com">
              投递简历
              <div class="circle">
                <img src="../static/home/circle_arrow_right.png" alt="" />
              </div>
            </a>
            <div class="close_icon" @click="showDialog = false"></div>
          </div>
        </div>
        <div class="body">
          <div class="job_desc_item">
            <div class="title">职责描述</div>
            <div class="desc_item">{{ currentJob.responsibilities }}</div>
            <!-- <div class="desc_item">2、负责客户现场产品便用异常的处理工作。</div>
            <div class="desc_item">3、负责配合销售新品推广的调机工作。</div>
            <div class="desc_item">4、应客户要求负责现场小批量跟线工作。</div>
            <div class="desc_item">5、客户现场基本信息收集工作。</div>
            <div class="desc_item">6、定期拜访客户。</div>
            <div class="desc_item">7、完成上级安排的的其他工作。</div> -->
          </div>
          <div class="job_desc_item">
            <div class="title">任职要求</div>
            <div class="desc_item">{{ currentJob.requirements }}</div>

            <!-- <div class="desc_item">
              1.硕士及以上学历，化学、聚合物、材料化学专业优先。
            </div>
            <div class="desc_item">
              2.具有至少5年以上研发浆料或者油墨的直接经验。
            </div>
            <div class="desc_item">
              3.熟悉以下分析仪器的原理和应用: FTHR,TGA,NMR,GCMS等。
            </div>
            <div class="desc_item">
              4.在以下领域有很深的理论和应用基础并熟悉主要的供货商:聚合物表面活性剂，溶剂，和触变剂。
            </div>
            <div class="desc_item">5.符合公司其他相关要求</div> -->
          </div>
        </div>
        <div class="submit_btn_mobile">
          <a class="submit_btn" href="mailto:hr@xinghanmaterials.com">
            投递简历
            <div class="circle">
              <img src="../static/home/circle_arrow_right.png" alt="" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactModule from "../components/contactModule.vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";
import HorizontalScrollInterval from "../components/HorizontalScrollInterval.vue";
import { TalentRecruitmentAPI } from "../api/api.js";
import { imgBaseUrl } from "../api/config";


export default {
  name: "Jobs",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    HorizontalScrollInterval,
    contactModule,
  },
  // computed: {
  //   workImages() {
  //     const images = [
  //       require("@/static/work/work_1.jpg"),
  //       require("@/static/work/work_2.jpg"),
  //       require("@/static/work/work_3.jpg"),
  //       require("@/static/work/work_4.jpg"),
  //       require("@/static/work/work_5.jpg"),
  //       require("@/static/work/work_6.jpg"),
  //       require("@/static/work/work_7.jpg"),
  //       require("@/static/work/work_8.jpg"),
  //       require("@/static/work/work_9.jpg"),
  //     ];
  //     // let arr = [...images]
  //     // let result = []
  //     // for (let i = 0; i < arr.length; i += 3) {
  //     //   result.push(arr.slice(i, i + 3));
  //     // }
  //     return images;
  //   },

  //   lifeImages() {
  //     const images = [
  //       require("@/static/life/life_1.jpg"),
  //       require("@/static/life/life_2.jpg"),
  //       require("@/static/life/life_3.jpg"),
  //       require("@/static/life/life_4.jpg"),
  //       require("@/static/life/life_5.jpg"),
  //       require("@/static/life/life_6.jpg"),
  //       require("@/static/life/life_7.jpg"),
  //       require("@/static/life/life_8.jpg"),
  //       require("@/static/life/life_9.jpg"),
  //     ];
  //     // let arr = [...images]
  //     // let result = []
  //     // for (let i = 0; i < arr.length; i += 3) {
  //     //   result.push(arr.slice(i, i + 3));
  //     // }
  //     return images;
  //   },
  // },
  data() {
    return {
      showDialog: false,
      introVisible: true,

      lifeImages: [],
      workImages: [],
      jobs: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,

      currentJob: {},
    };
  },

  created() {
    this.getPageData();
    this.getJobs();
  },


  methods: {
    // 获取工作 生活图片
    getPageData() {
      // 生活 工作 图片列表
      TalentRecruitmentAPI.getBasicInfo("all").then((res) => {
        console.log("all", res);
        const { liveInXinghan, workInXinghan } = res;
        this.lifeImages = (liveInXinghan || []).map((item) => {
          return imgBaseUrl + item.imageUrl;
        });
        this.workImages = (workInXinghan || []).map((item) => {
          return imgBaseUrl + item.imageUrl;
        });
      });
    },
    // 职位列表
    getJobs() {
      // 职位列表
      TalentRecruitmentAPI.getPositions({
        page: this.pageIndex,
        size: this.pageSize,
        department: "",
        location: "",
        status: "open", // open（开放）、closed（关闭）
      }).then((res) => {
        console.log("职位列表", res);
        this.jobs = res.records;
        this.total = res.total;
      });
    },
    // 职位详情
    openJobDetail(item) {
      this.currentJob = item;
      this.showDialog = true;
    },
    // 监听内容进入可视区域  -- 数字开始滚到
    setupSectionObserver() {
      const options = {
        root: null,
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      };

      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          switch (target.dataset.section) {
            case "intro":
              this.introVisible = true;
              break;
            default:
              break;
          }
          // 触发后取消观察，避免重复计算
          this.sectionObserver.unobserve(target);
        });
      }, options);

      this.registerSection(this.$refs.introSection, "intro");
    },
    registerSection(sectionEl, name) {
      if (!sectionEl || !this.sectionObserver) return;
      sectionEl.dataset.section = name;
      this.sectionObserver.observe(sectionEl);
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding-bottom: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      // padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/job/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      h1 {
        margin-top: 275px;
        font-size: 48px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 100px;
  }

  .intro {
    padding: 0 !important;
    max-width: 1920px;
    margin: 0 auto;
    height: 904px;
    background: url("../static/job/bg.png") center/cover no-repeat;

    padding-top: 70px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }
    }

    .desc {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #888888;
      line-height: 28px;
    }

    .numbers {
      margin-top: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: center;

      .number-counter {
        min-width: 150px;
        font-weight: 500;
        font-size: 80px;
        color: #0248ff;
        margin-bottom: 10px;
      }

      p {
        white-space: nowrap;
        font-weight: 400;
        font-size: 16px;
        color: #9e9e9e;
      }
    }
  }

  .good {
    .img-wrapper {
      position: relative;
      width: 1400x;
      height: 706px;
      background: url("../static/job/good.png") center/cover no-repeat;
    }

    .advantages,
    .benefit {
      cursor: default;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 0;

      .item {
        text-align: center;
      }

      img {
        margin-bottom: 24px;
      }

      img:hover {
        transform: scale(1.2);
      }

      .txt {
        font-size: 16px;
        color: #fff;
      }
    }

    .advantages {
      width: 100%;
      position: absolute;
      bottom: 414px;
    }

    .benefit {
      width: 100%;
      position: absolute;
      bottom: 70px;

      .txt {
        color: #7e828e;
      }
    }

    .advantages_pc {
      display: flex;
    }

    .benefit_pc {
      display: flex;
    }

    .advantages_mobile {
      display: none;
    }

    .benefit_mobile {
      display: none;
    }
  }

  .life,
  .work,
  .job {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 72px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .tag {
        margin-top: 24px;
        width: 24px;
        height: 3px;
        background: #0248ff;
      }
    }
  }

  .life,
  .work {
    .work_pc {
      display: block;
    }

    .life_pc {
      display: block;
    }

    .work_mobile {
      display: none;
    }

    .life_mobile {
      display: none;
    }
    .partner-logo {
      img {
        // width: 416px;
        // height: 286px;
        border-radius: 8px;
      }
    }

    .custom {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      img {
        width: 416px;
        height: 286px;
        border-radius: 8px;
      }
    }
  }

  .job {
    padding-bottom: 0 !important;

    .job_list {
      display: flex;
      flex-direction: column;
      gap: 30px;

      .job_item {
        padding: 0 43px;
        background: #f9fafc;
        border-radius: 8px;
        overflow: hidden;

        .head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 73px;
          border-bottom: 1px solid #e5e5e5;

          .left {
            display: flex;
            align-items: center;

            .job_name {
              margin-left: 16px;
              font-size: 20px;
              color: #363636;
              font-weight: bold;
            }
          }

          .right {
            font-size: 14px;
            color: #a6a6a7;
          }
        }

        .detail {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 70px;

          .left {
            display: flex;
            gap: 117px;
            font-size: 14px;
            color: #888888;
            .arrow {
              display: none;
            }
          }

          .right {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: url("../static/job/arrow_right_default.png")
              center/cover no-repeat;
          }
        }
      }

      .job_item:hover {
        background: #ecf1ff;

        .detail {
          .right {
            background: url("../static/home/circle_arrow_right_light.png")
              center/cover no-repeat;
          }
        }
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 72px 0;

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 32px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }

    ::v-deep .btn-prev:hover,
    ::v-deep .btn-next:hover,
    ::v-deep .el-pager li:not(.disabled):hover {
      background: #ecf3fd;
      color: #323232;
    }

    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .dialog_masker {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 99999;

    .dialog_content {
      width: 80%;
      background: #fff;

      .header {
        position: relative;
        padding: 36px 55px;
        background: #ecf3fd;

        .job_name {
          margin-bottom: 28px;
          font-weight: 800;
          font-size: 20px;
          color: #0248ff;
          line-height: 28px;
        }

        .details {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left {
            display: flex;
            align-items: center;
            gap: 54px;

            font-size: 14px;
            color: #000000;
          }

          .submit_btn {
            display: inline-flex;
            align-items: center;
            line-height: 1;
            padding: 12px 25px;
            font-size: 16px;
            background: #0248ff;
            border-radius: 50px;
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;

            .circle {
              margin-left: 24px;
            }
          }

          .close_icon {
            position: absolute;
            right: 16px;
            top: 16px;
            width: 15px;
            height: 15px;
            background: url("../static/job/close.png") center/cover no-repeat;
          }
        }
      }

      .body {
        padding: 0 55px 40px;

        .job_desc_item {
          .title {
            margin: 30px 0 10px;
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 28px;
          }

          .desc_item {
            font-size: 14px;
            color: #888888;
            line-height: 24px;
            white-space: pre-wrap;
          }
        }
      }

      .submit_btn_mobile {
        display: none;
      }
    }
  }
}

// mobile
@media (max-width: 750px) {
  .section {
    padding-bottom: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/job/head_bg_mobile.png");
    background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px;

      h1 {
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }

      .tabs {
        display: none !important;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 50px;
  }

  .intro {
    padding: 0 !important;
    max-width: 1920px;
    margin: 0 auto;
    height: 636px;
    background: url("../static/job/bg_mobile.png") center/cover no-repeat;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }
    }

    .desc {
      text-align: left;
      font-weight: 400;
      font-size: 12px;
      color: #888888;
      line-height: 24px;
    }

    .numbers {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: center;

      .number-counter {
        font-weight: 500;
        font-size: 40px;
        color: #0248ff;
        margin-bottom: 10px;
      }

      p {
        white-space: nowrap;
        font-weight: 400;
        font-size: 10px;
        color: #9e9e9e;
      }
    }
  }

  .good {
    .img-wrapper {
      position: relative;
      height: 500px;
      background: url("../static/job/good_mobile.png") center/cover no-repeat;
    }

    .advantages,
    .benefit {
      cursor: default;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 0;

      .item {
        text-align: center;
      }

      img {
        width: 36px;
        height: 36px;
        margin-bottom: 12px;
      }

      .txt {
        font-size: 12px;
        color: #fff;
      }
    }

    .advantages {
      width: 100%;
      position: absolute;
      bottom: 363px;
    }

    .advantages1 {
      bottom: 363px;
    }

    .advantages2 {
      bottom: 277px;
    }

    .benefit {
      width: 100%;
      position: absolute;
      bottom: 70px;

      .txt {
        color: #7e828e;
      }
    }

    .benefit1 {
      bottom: 96px;
    }

    .benefit2 {
      bottom: 17px;
    }

    .advantages_pc {
      display: none;
    }

    .benefit_pc {
      display: none;
    }

    .advantages_mobile {
      display: flex;
    }

    .benefit_mobile {
      display: flex;
    }
  }

  .life,
  .work,
  .job {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 36px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .tag {
        margin-top: 12px;
        width: 12px;
        height: 2px;
        background: #0248ff;
      }
    }
  }

  .life,
  .work {
    .work_pc {
      display: none;
    }

    .life_pc {
      display: none;
    }

    .work_mobile {
      display: block;
    }

    .life_mobile {
      display: block;
    }

    .partner-logo {
      img {
        // width: 416px;
        // height: 286px;
        border-radius: 8px;
      }
    }

    .custom {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      img {
        width: 278px;
        height: 192px;
        border-radius: 4px;
      }
    }

    /deep/.el-carousel__arrow--left {
      left: 0;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(236, 241, 255, 1);
    }

    /deep/.el-carousel__arrow--right {
      right: 0;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(236, 241, 255, 1);
    }
  }

  .job {
    padding-bottom: 0 !important;

    .job_list {
      display: flex;
      flex-direction: column;
      gap: 30px;

      .job_item {
        padding: 0 20px;
        background: #f9fafc;
        border-radius: 4px;
        overflow: hidden;

        .head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 48px;
          border-bottom: 1px solid #e5e5e5;

          .left {
            display: flex;
            align-items: center;

            .job_name {
              margin-left: 8px;
              font-size: 16px;
              color: #363636;
              font-weight: bold;
            }
          }

          .right {
            font-size: 14px;
            color: #a6a6a7;
          }
        }

        .detail {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 13px 0;
          // height: 70px;

          .left {
            display: flex;
            flex-wrap: wrap;
            gap: 5px 20px;
            font-size: 14px;
            color: #888888;

            .item {
              white-space: nowrap;
            }

            .arrow {
              margin-left: auto;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: url("../static/job/arrow_right_default.png")
                center/cover no-repeat;
            }
          }

          .right {
            display: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: url("../static/job/arrow_right_default.png")
              center/cover no-repeat;
          }
        }
      }

      .job_item:hover {
        background: #ecf1ff;

        .detail {
          .right {
            background: url("../static/home/circle_arrow_right_light.png")
              center/cover no-repeat;
          }
        }
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 0;
    transform: scale(0.6);

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 32px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }

    ::v-deep .btn-prev:hover,
    ::v-deep .btn-next:hover,
    ::v-deep .el-pager li:not(.disabled):hover {
      background: #ecf3fd;
      color: #323232;
    }

    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .dialog_masker {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 99999;

    .dialog_content {
      z-index: 2000;
      width: calc(100% - 48px);
      height: 80vh;
      overflow: auto;
      background: #fff;
      padding-bottom: 20px;

      .header {
        position: relative;
        padding: 18px 27px;
        background: #ecf3fd;

        .job_name {
          margin-bottom: 14px;
          font-weight: 800;
          font-size: 20px;
          color: #0248ff;
          // line-height: 28px;
        }

        .details {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            row-gap: 5px;
            column-gap: 27px;

            font-size: 12px;
            color: #000000;
          }

          .submit_btn {
            display: none !important;
            display: inline-flex;
            align-items: center;
            line-height: 1;
            padding: 12px 25px;
            font-size: 16px;
            background: #0248ff;
            border-radius: 50px;
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;

            .circle {
              margin-left: 24px;
            }
          }

          .close_icon {
            position: absolute;
            right: 16px;
            top: 16px;
            width: 15px;
            height: 15px;
            background: url("../static/job/close.png") center/cover no-repeat;
          }
        }
      }

      .body {
        padding: 0 24px 24px;

        .job_desc_item {
          .title {
            margin: 30px 0 5px;
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 28px;
          }

          .desc_item {
             white-space: pre-wrap;
            font-size: 12px;
            color: #888888;
            line-height: 24px;
          }
        }
      }

      .submit_btn_mobile {
        background: #fff;
        text-align: center;

        .submit_btn {
          margin: 0 auto;
          display: inline-flex;
          align-items: center;
          line-height: 1;
          padding: 6px 12px;
          font-size: 12px;
          background: #0248ff;
          border-radius: 50px;
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;

          .circle {
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>
